import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import { useAppSelector } from "src/store/store";

const LandingHeader: React.FC = () => {
  const { firstName, alias } = useAppSelector((state) => state.user);
  const displayName = firstName || alias || "User";

  return (
    <Column spacing="300" spacingInset="500 500 400">
      <Row alignmentHorizontal="justify" alignmentVertical="center" spacingInset="none none 500" className="home-header-row">
        <Row spacing="none">
          <Text className="home-header-row__title" >Safety</Text>
          <Text type="h600">Genie </Text>
        </Row>
        <img src="/WHS-Workplace_logo.png" alt="WHS Workplace" style={{ height: 32 }} />
      </Row>
      <Text type="h600">Hello, {displayName}</Text>
    </Column>
  );
};

export default LandingHeader;
